<ui-dropdown
	#uiDropdown
	[items]="intakeFormStatusDropdownOptions"
	placeholder="Select Status"
	[dropdownItemTemplate]="dropdownItemTemplate"
	[testHook]="testHooks.Dropdown"
>
	<ui-button
		dropdown-trigger
		preset="EXTRA_LOW_EMPHASIS"
		[label]="viewModel_().dropdownItem?.title?.label || 'Select Status'"
		[icon]="viewModel_().dropdownItem?.title?.icon"
		[iconClasses]="viewModel_().dropdownItem?.title?.iconClasses"
		size="md"
		rightIcon="chevron-down"
		[testHook]="testHooks.Button"
	/>

	<ng-template #dropdownItemTemplate let-item>
		<button
			(click)="selectItem($event, item)"
			class="p-2 pr-3 rounded-md duration-300 flex items-center gap-x-2 text-gray-500 hover:bg-gray-100"
			[ngClass]="{
				'bg-gray-50': item.id === currIntakeFormStatus_(),
			}"
		>
			<i-tabler
				*ngIf="item.title?.icon"
				class="h-4 w-4"
				[name]="item.title.icon"
				[class]="item.title?.iconClasses"
			/>
			<div class="text-xs text-nowrap">
				{{ item.title?.label }}
			</div>
		</button>
	</ng-template>
</ui-dropdown>
